import {v7} from "uuid";

export class UuidHelper {

    public static generateV7(): string {
        return v7();
    }
}